<template>
  <div>
    <van-field size="large" name="uploader" label="上传图片">
      <template #input>
        <van-uploader
          v-model="uploader"
          v-bind="isPc ? { 'preview-full-image': false } : {}"
          v-on="isPc ? { 'click-preview': onPcPreview } : {}"
        >
          <div></div>
        </van-uploader>
        <div v-if="uploader.length < count" class="van-uploader__upload" @click="chooseImage">
          <van-icon color="#dcdee0" style="font-size: 24px;" name="photograph"></van-icon>
        </div>
        <!-- PC端隐藏文件选择框 -->
        <input
          v-if="isPc"
          ref="pcFileInput"
          type="file"
          accept="image/*"
          :multiple="count - uploader.length > 1"
          style="display:none"
          @change="onPcFileChange"
        />
      </template>
    </van-field>

    <!-- PC端自定义图片预览弹层（挂载到 body，避免父容器 transform 破坏 fixed） -->
    <div ref="pcPreviewMask" v-show="isPc && pcPreviewUrl" class="pc-preview-mask" @click="pcPreviewUrl = null">
      <div class="pc-preview-box" @click.stop>
        <img :src="pcPreviewUrl" class="pc-preview-img" />
        <div class="pc-preview-close" @click="pcPreviewUrl = null">✕</div>
      </div>
    </div>
  </div>
</template>
<script>
import { uploaderfiles } from '@/api/base';
import { client } from '@/utils/oss';
import { isPcClient } from '@/views/PC/utils';
export default {
  props: {
    value: Array,
  },
  data() {
    return {
      uploader: this.value,
      count: 9,
      isPc: isPcClient(),
      pcPreviewUrl: null,
    };
  },
  mounted() {
    if (this.isPc) {
      document.body.appendChild(this.$refs.pcPreviewMask);
    }
  },
  beforeDestroy() {
    const el = this.$refs.pcPreviewMask;
    if (el && el.parentNode) {
      el.parentNode.removeChild(el);
    }
  },
  methods: {
    onPcPreview(file) {
      this.pcPreviewUrl = file.url || (file.content);
    },
    chooseImage() {
      if (this.isPc) {
        this.$refs.pcFileInput.value = '';
        this.$refs.pcFileInput.click();
        return;
      }
      let that = this;
      let count = Number(this.count) - Number(this.uploader.length);
      wx.chooseImage({
        count: count, // 默认9
        sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: function(res) {
          that.syncUpload(res.localIds, 0);
        },
      });
    },
    compressImage(file) {
      return new Promise((resolve) => {
        const MAX_PX = 2000; // 长边不超过 2000px
        const QUALITY = 0.85;
        const img = new Image();
        const blobUrl = URL.createObjectURL(file);
        img.onload = () => {
          URL.revokeObjectURL(blobUrl);
          let { width, height } = img;
          if (width > MAX_PX || height > MAX_PX) {
            if (width >= height) {
              height = Math.round((height * MAX_PX) / width);
              width = MAX_PX;
            } else {
              width = Math.round((width * MAX_PX) / height);
              height = MAX_PX;
            }
          }
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          canvas.getContext('2d').drawImage(img, 0, 0, width, height);
          canvas.toBlob((blob) => resolve(blob), 'image/jpeg', QUALITY);
        };
        img.onerror = () => { URL.revokeObjectURL(blobUrl); resolve(file); };
        img.src = blobUrl;
      });
    },
    async onPcFileChange(event) {
      const files = Array.from(event.target.files);
      if (!files.length) return;
      const remaining = Number(this.count) - Number(this.uploader.length);
      const toUpload = files.slice(0, remaining);
      this.$toast.loading({ message: '上传中...', forbidClick: true });
      try {
        for (const file of toUpload) {
          const compressed = await this.compressImage(file);
          const key = `yca/${Date.now()}_${Math.random().toString(36).slice(2)}.jpg`;
          const result = await client.put(key, compressed);
          const url = result.url + '?x-oss-process=image/resize,l_1400';
          this.uploader.push({ url });
          this.$emit('input', this.uploader);
        }
      } catch (err) {
        this.$toast('上传失败，请重试');
        console.error('OSS upload error', err);
      } finally {
        this.$toast.clear();
      }
    },
    async syncUpload(localIds, num) {
      this.$toast.loading({
        message: '上传中...',
        forbidClick: true,
      });
      let that = this;
      let id = String(localIds[num]);
      if (id.indexOf('wxlocalresource') != -1) {
        id = id.replace('wxlocalresource', 'wxLocalResource');
      }
      await wx.uploadImage({
        localId: id, // 需要上传的图片的本地ID，由chooseImage接口获得
        isShowProgressTips: 1, // 默认为1，显示进度提示
        success: function(res) {
          // that.list.push(res.serverId);
          if (Number(num) < localIds.length) {
            // setTimeout(function() {
            // that.syncUpload(localIds, Number(num) + 1);
            that.uploaderfilefun(res.serverId, localIds, Number(num) + 1);
            // }, 1000);
          }
          // else {
          //   let str = '';
          //   that.list.map(item => {
          //     str += 'mediaIds=' + item + '&';
          //   });
          //   uploaderfile(str).then(res => {
          //     console.log(res);
          //     // that.listimg = res.data;
          //     let listarr = [];
          //     res.data.map(item => {
          //       listarr.push({ url: item });
          //     });
          //     that.uploader = listarr;
          //     that.$emit('input', listarr);
          //   });
          // }
        },
        fail: function() {
          // that.failtext = e;
          // that.syncUpload(localIds, num);
        },
      });
    },
    async uploaderfilefun(serverId, localId, num) {
      console.log(num);
      let that = this;
      let str = 'mediaIds=' + serverId;
      await uploaderfiles(str).then(res => {
        that.uploader.push({ url: res.data[0] + '?x-oss-process=image/resize,l_1400'});
        that.$emit('input', that.uploader);
        if (Number(num) < serverId.length) {
          that.syncUpload(localId, num);
        } else {
          this.$toast.clear();
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.uploader_box {
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  .van-uploader {
    position: relative;
    display: inline-block;
    .van-uploader_wrapper {
      display: flex;
      -webkit-flex-wrap: wrap;
      flex-wrap: wrap;
      .van-uploader__upload {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        width: 70px;
        height: 80px;
        margin: 0 8px 8px 0;
        background-color: #f7f8fa;
        .uploader__input {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          cursor: pointer;
          opacity: 0;
        }
      }
      .van-uploader__preview {
        position: relative;
        margin: 0 8px 8px 0;
        cursor: pointer;
        .van-uploader__preview-image {
          display: block;
          width: 80px;
          height: 80px;
          overflow: hidden;
          position: relative;
          .van-image__img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .van-uploader__preview-delete {
          position: absolute;
          top: 0;
          right: 0;
          width: 14px;
          height: 14px;
          background-color: rgba(0, 0, 0, 0.7);
          border-radius: 0 0 0 12px;
          .van-uploader__preview-delete-icon {
            position: absolute;
            top: -2px;
            right: -2px;
            color: #fff;
            font-size: 16px;
            -webkit-transform: scale(0.5);
            transform: scale(0.5);
          }
        }
      }
      .van-uploader__mask {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #fff;
        background-color: rgba(50, 50, 51, 0.88);
        .van-uploader__loading {
          width: 22px;
          height: 22px;
          color: #fff;
          position: relative;
          vertical-align: middle;
          .van-loading__spinner {
            position: relative;
            display: inline-block;
            width: 30px;
            max-width: 100%;
            height: 30px;
            max-height: 100%;
            vertical-align: middle;
            animation: van-rotate 0.8s linear infinite;
            .van-loading__circular {
              display: block;
              width: 100%;
              height: 100%;
            }
          }
          .van-loading__spinner--circular {
            animation-duration: 2s;
          }
        }
        .van-uploader__mask-message {
          margin-top: 6px;
          padding: 0 4px;
          font-size: 12px;
          line-height: 14px;
        }
      }
    }
  }
}

.pc-preview-mask {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
}
.pc-preview-box {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
}
.pc-preview-img {
  display: block;
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 4px;
}
.pc-preview-close {
  position: absolute;
  top: -14px;
  right: -14px;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  border-radius: 50%;
  cursor: pointer;
  font-size: 14px;
  &:hover {
    background: rgba(0, 0, 0, 0.9);
  }
}
</style>
